import { useNavigate } from 'react-router';
import { useTranslation } from "react-i18next";
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/Routers/root"
import { useMediaQuery } from "../../../Styles/mediaQueries";
import { CheckBox, CheckStyles, ProgressCircle } from '../..';
import { colors, fonts } from "../../../Styles";

import Widget2 from "../../BaseComponents/widget copy 2";
import ReportShortCutCopy from "../../Reports/reportShortCut copy"

import { TestData as ReportData } from "../../../Assets/TestData/reportTemplates";
import { useDefaultProgressCircles } from '../../../Assets/TestData/lf_dashboard';
import { myChosenFilters } from '../../../Assets/TestData/animalData';

/**
 * Feeding
 * @returns A widget widt feeding calendar.
 */
export default function Feeding() {
  const {t} = useTranslation();
  const navigator = useNavigate()
  const tablet = useMediaQuery(`(min-width: 601px) and (max-width: 1021px)`);

  const filtersToShow = { filters: [{filtersId: 1}, {filtersId: 2}]}

    const getFilterName = (filtersId: number) => {
      const filter = myChosenFilters.find(filter => filter.filtersId === filtersId);
      return filter ? filter.filterName : "";
    };

  const progressCirclesToShow = { progressCircles: [{progressCircleId: 1}, {progressCircleId: 2}] }
  const defaultProgressCircles = useDefaultProgressCircles();
  const filteredProgressCircles = defaultProgressCircles.filter(circle =>
    progressCirclesToShow.progressCircles.some(show => show.progressCircleId === circle.progressCircleId)
  );
  const isProgressCircleChecked = (progressCircleId: number) =>
    progressCirclesToShow.progressCircles.some(
      (p) => p.progressCircleId === progressCircleId
    );
  

  return(
      <Widget2
        header={<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{t("feed.feedCorrections.feeding")}</p>}
        onSave={() => (console.log("save"))}
        rightContent={ <>
<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center"}}>{"Auto Reports"}</p>
        <div style={{backgroundColor: colors.greySecondary, width: "100%", height: "2px"}}/>
          {filtersToShow.filters.map((filter, index) => (
            <ReportShortCutCopy
              key={index}
              header={getFilterName(filter.filtersId)}
              amount={0}
              onClick={() => RootNavigation(navigator, Pages.animals, undefined, true, { selected: filter.filtersId })
              }
            />
          ))}
        </> }
        leftContent={ <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridAutoRows: "auto", height: "100%", width: "100%", gap: "30px"}}>
          {filteredProgressCircles.map((progressCircle, index) => {
            return (
              <ProgressCircle
                key={progressCircle.progressCircleId}
                header={progressCircle.header}
                unit={progressCircle.unit}
                progressed={progressCircle.progressed}
                total={progressCircle.total}
              />
            );
          })}
        </div> }

        editMode={{
          editLeftContent: ( <>
            <div style={{display: "grid", gridTemplateColumns: "repeat(1fr)", gridAutoRows: "auto", width: "100%", height: "100%", gap: "10px 30px", overflowY: "scroll", scrollbarColor: colors.greyTertiary+colors.transparent, scrollbarWidth: "thin" }}>
              {defaultProgressCircles.map((progressCircle, index) =>
                <CheckBox
                  key={progressCircle.progressCircleId}
                  text={progressCircle.header}
                  isChecked={isProgressCircleChecked(progressCircle.progressCircleId)}
                  checkStyle={CheckStyles.grey}
                />
              )}
            </div> 
          </> )
        }}
      />
  )
}